import '../scss/main.scss';

import Forms from './forms';
import Video from './video';

Forms();
Video();
